import type { Comment } from "../../models/contador.ts";
import { fetchFromContador } from "./contador-fetch.ts";

export async function createEntityComment({
    commentableType,
    commentableId,
    text,
}: {
    commentableType: "property" | "bank_account" | "vendor";
    commentableId: string;
    text: string;
}): Promise<Comment> {
    return fetchFromContador<Comment>(`/api/v1/comments`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            commentableType,
            commentableId,
            text,
        }),
    });
}

export async function updateEntityComment(
    commentId: string,
    payload: { text?: string; pinned?: boolean; archived?: string | null },
): Promise<Comment> {
    return fetchFromContador<Comment>(`/api/v1/comments/${commentId}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });
}

export async function deleteEntityComment(commentId: string): Promise<void> {
    await fetchFromContador<void>(`/api/v1/comments/${commentId}`, {
        method: "DELETE",
    });
}
